import React from 'react';
import MyInput from "../components/UI/input/MyInput";
import MyButton from "../components/UI/button/MyButton";
import {useContext} from "react";
import {AuthContext} from "../context";

const Login = () => {
    const {isAuth, setIsAuth} = useContext(AuthContext)
    const login = event => {
        event.preventDefault();
        setIsAuth(true);
        localStorage.setItem('auth', 'true')
    }
    return (
        <div style={{ padding: '0 10px' }}>
            <h1>Page for login</h1>
            <form  onClick={login}>
                <MyInput type="text" placeholder="Enter login" />
                <MyInput type="password" placeholder="Enter password" />
                <MyButton>Login</MyButton>
            </form>
        </div>
    );
};

export default Login;